module.exports = __webpack_public_path__ + "static/media/max-messenger-sign-logo.46c8cef9.svg";